import React, {useEffect, useMemo, useRef, useState} from 'react'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import * as API from '../../api'

interface CropperComponentProps {
  imageFile: File | null
  setCroppedImage: (url: string) => void
  setShowCropper: (value: boolean) => void
  setUploadResponse: (value: any) => void
}

const ImageCropper: React.FC<CropperComponentProps> = ({
  imageFile,
  setCroppedImage,
  setShowCropper,
  setUploadResponse,
}) => {
  const cropperRef = useRef<any>(null)
  const [uploading, setUploading] = useState(false)
  const [uploadError, setUploadError] = useState('')
  const imageUrl = useMemo(() => (imageFile ? URL.createObjectURL(imageFile) : ''), [imageFile])

  useEffect(() => {
    return () => {
      if (imageUrl) URL.revokeObjectURL(imageUrl)
    }
  }, [imageUrl])

  async function cropImage() {
    const cropper = cropperRef.current?.cropper
    if (!cropper || uploading) return

    setUploading(true)
    setUploadError('')

    try {
      const base64Image = cropper
        .getCroppedCanvas({maxWidth: 300, maxHeight: 300})
        .toDataURL('image/jpeg', 0.8)
      const response = await API.uploadImage({base64Image})

      setUploadResponse(response.data)
      setCroppedImage(base64Image)
      setShowCropper(false)
    } catch {
      setUploadError('Não foi possível enviar a imagem. Tente novamente.')
    } finally {
      setUploading(false)
    }
  }

  return (
    <div className='ua-image-cropper' aria-busy={uploading}>
      <Cropper
        src={imageUrl}
        style={{height: 'clamp(260px, 42vh, 400px)', width: '100%'}}
        initialAspectRatio={1}
        aspectRatio={1}
        preview='.img-preview'
        guides={false}
        ref={cropperRef}
      />

      <div className='ua-image-cropper__actions'>
        <span role='alert'>{uploadError}</span>
        <div>
          <button
            type='button'
            onClick={() => setShowCropper(false)}
            className='ua-secondary-button'
            disabled={uploading}
          >
            Cancelar recorte
          </button>
          <button
            type='button'
            onClick={cropImage}
            className='ua-primary-button'
            disabled={uploading}
          >
            {uploading && <span className='ua-spinner' />}
            {uploading ? 'Enviando…' : 'Confirmar foto'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ImageCropper
